/**
 * The guide half of a free tool page: the ordered steps a reader follows and the
 * three facts that bound the run.
 *
 * `toolSeo.ts` owns the three-question summary and the outbound links. This file
 * owns the depth those questions cannot carry inside a 100-word budget: the steps
 * become a visible ordered list AND the `HowTo` node in `lib/seo/toolSchema.ts`,
 * and the limits become the reference table every page was missing.
 *
 * Copy is split across `toolGuideCreator.ts` and `toolGuideResearch.ts` along the
 * same boundary `src/pages/tools/` already uses, because one map of 28 entries does
 * not fit the 300-line file rule. The shape lives in `toolGuideShape.ts` so those two
 * can type themselves without importing this file back.
 */

import type { ToolGuide } from './toolGuideShape';
import { TOOL_GUIDE_CREATOR } from './toolGuideCreator';
import { TOOL_GUIDE_RESEARCH } from './toolGuideResearch';

export const TOOL_GUIDE: Readonly<Record<string, ToolGuide>> = {
  ...TOOL_GUIDE_CREATOR,
  ...TOOL_GUIDE_RESEARCH,
};
